import Cookies from 'js-cookie';

enum RequestHeaderNames {
  appVersion = 'X-CVNA-AppVersion',
  bcid = 'X-CVNA-BrowserCookieId',
  deviceId = 'X-CVNA-DeviceId',
  deviceType = 'X-CVNA-DeviceType',
  platform = 'X-CVNA-Platform'
}

const createMobileRequestHeaders = () => {
  const headers: { [key in RequestHeaderNames]?: string } = {};

  return Object.values(RequestHeaderNames).reduce((acc, headerName) => {
    acc[headerName] = Cookies.get(headerName);

    return acc;
  }, headers);
};

const setDeviceType = () => {
  const device = JSON.parse(localStorage.getItem('deviceInformation') ?? '{}');

  if (+device?.isBrowser) {
    return 'Desktop';
  }

  if (+device?.isTablet) {
    return 'Tablet';
  }

  if (+device?.isMobilePhone) {
    return 'Mobile';
  }

  return 'Other';
};

const createWebRequestHeaders = () => {
  return {
    [RequestHeaderNames.appVersion]: '',
    [RequestHeaderNames.bcid]: Cookies.get('BrowserCookieId'),
    [RequestHeaderNames.deviceId]: '',
    [RequestHeaderNames.deviceType]: setDeviceType(),
    [RequestHeaderNames.platform]: 'Web'
  };
};

export const checkForMobileCookies = (
  mobileHeaders = createMobileRequestHeaders()
) => {
  const { appVersion, platform } = RequestHeaderNames;

  return (
    mobileHeaders?.[appVersion] !== undefined ||
    mobileHeaders?.[platform] !== undefined
  );
};

export const getRequestHeaders = () => {
  const mobileHeaders = createMobileRequestHeaders();

  return checkForMobileCookies(mobileHeaders)
    ? mobileHeaders
    : createWebRequestHeaders();
};
